import React from 'react';

interface TransactionsProp {
  fill: string;
}

const Transactions: React.FC<TransactionsProp> = (props: TransactionsProp): JSX.Element => {
  return (
    <svg width='100%' viewBox='0 0 27 30'>
      <g
        id='transactions-NextGen-POS'
        stroke='none'
        strokeWidth='1'
        fill={props.fill}
        fillRule='evenodd'
      >
        <g
          id='transactions-Idle-&gt;-Search-Bar'
          transform='translate(-588.000000, -116.000000)'
          fill={props.fill}
          fillRule='nonzero'
        >
          <g id='transactions-Group-7' transform='translate(37.000000, 103.000000)'>
            <g id='transactions-Chips'>
              <g
                id='transactions-Chips-/-Action-/-Filled-/-with-Avatar-/-Enabled-Copy-5'
                transform='translate(533.000000, 0.000000)'
              >
                <g
                  id='transactions-BODY-2-COLOR-&amp;-STYLE'
                  transform='translate(17.923077, 13.000000)'
                >
                  <path
                    d='M24.8946701,4.5 C24.0483511,4.5 23.4841385,5.25 23.4841385,6.15 L23.4841385,21 C23.4841385,21.9 24.0483511,22.5 24.8946701,22.65 C25.7409891,22.65 26.3052017,21.9 26.3052017,21 L26.3052017,6.15 C26.3052017,5.25 25.7409891,4.5 24.8946701,4.5 L24.8946701,4.5 Z M19.8167563,0 L3.17248333,0 C1.90300488,0 0.915632754,1.05 0.915632754,2.4 L0.915632754,23.1 C0.915632754,24.45 1.90300488,25.5 3.17248333,25.5 L5.14722758,25.5 L5.14722758,28.5 C5.14722758,29.4 5.71144022,30 6.55775919,30 L15.0209488,30 C15.8672678,30 16.4314804,29.4 16.4314804,28.5 L16.4314804,25.5 L19.8167563,25.5 C21.0862347,25.5 22.0736069,24.45 22.0736069,23.1 L22.0736069,2.4 C22.0736069,1.05 21.0862347,0 19.8167563,0 L19.8167563,0 Z M3.73669597,9 L7.96829079,9 L7.96829079,12 L3.73669597,12 L3.73669597,9 L3.73669597,9 Z M13.6104172,13.5 L13.6104172,16.5 L9.3788224,16.5 L9.3788224,13.5 L13.6104172,13.5 L13.6104172,13.5 Z M9.3788224,12 L9.3788224,9 L13.6104172,9 L13.6104172,12 L9.3788224,12 L9.3788224,12 Z M13.6104172,18 L13.6104172,21 L9.3788224,21 L9.3788224,18 L13.6104172,18 L13.6104172,18 Z M3.73669597,13.5 L7.96829079,13.5 L7.96829079,16.5 L3.73669597,16.5 L3.73669597,13.5 L3.73669597,13.5 Z M3.73669597,21 L3.73669597,18 L7.96829079,18 L7.96829079,21 L3.73669597,21 L3.73669597,21 Z M7.96829079,28.5 L6.55775919,28.5 L6.55775919,25.5 L7.96829079,25.5 L7.96829079,28.5 L7.96829079,28.5 Z M15.0209488,28.5 L10.789354,28.5 L10.789354,25.5 L15.0209488,25.5 L15.0209488,28.5 L15.0209488,28.5 Z M19.2525437,21 L15.0209488,21 L15.0209488,18 L19.2525437,18 L19.2525437,21 L19.2525437,21 Z M19.2525437,16.5 L15.0209488,16.5 L15.0209488,13.5 L19.2525437,13.5 L19.2525437,16.5 L19.2525437,16.5 Z M19.2525437,12 L15.0209488,12 L15.0209488,9 L19.2525437,9 L19.2525437,12 L19.2525437,12 Z M19.2525437,6 L3.73669597,6 L3.73669597,3 L19.2525437,3 L19.2525437,6 Z'
                    id='transactions-Shape'
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Transactions;
